import { Button } from '@design/components/button/Button';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './CacheError.module.scss';
import ErrorRobot from './cache-error.svg';

interface CacheErrorProps {
  onClick?: () => void;
  className?: string;
}

export const CacheError = ({
  onClick = () => window.location.reload(),
  className,
}: CacheErrorProps) => {
  const { t } = useTranslation('error');

  return (
    <section
      data-testid="cache-error-view"
      className={clsx(styles.section, className)}
    >
      <ErrorRobot alt={t('error:notFound.pageText')} viewBox="0 0 74 70" />
      <p className={styles.message}>{t('error:cacheError.message')}</p>
      <Button
        data-testid="cache-error-view-btn"
        label={t('error:cacheError.reload')}
        onClick={onClick}
        variant="secondary"
      />
    </section>
  );
};
